import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/usertask');

class UserTaskApiAgency {

	static list (userTaskFilterForDashboard: IUserTaskFilterForDashboardModel) {
		return client.post<IUserTaskModel[]>('list', userTaskFilterForDashboard);
	}

	static add (addUserTaskModel: IAddUserTaskModel) {
		return client.post<IUserTaskModel>('', addUserTaskModel);
	}

	static update (id: number, updateUserTaskModel: IUpdateUserTaskModel) {
		return client.put<IUserTaskModel>(id.toString(), updateUserTaskModel);
	}

	static delete (id: number) {
		return client.delete<void>(id.toString());
	}
}

export default UserTaskApiAgency;
